export default "__VITE_ASSET__V42$b8Vj__"